module.exports = Roo.locales['zh-CN'];